<template>
  <div class="resume">
    <table class="d-table">
      <thead>
      <tr>
        <th>Stillingstype</th>
        <th>Alder</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="persona in personale">
        <td>{{ persona.title }}</td>
        <td>{{ persona.numberOfMales }}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  props: {
    personaleskema: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      userTypesInHash: {
        'LA': 'Lærere',
        'BH': 'Børnehaveklasseledere',
        'PA': 'Pædagoger',
        'LE': 'Ledere',
        'AN': 'Andre med undervisningsopgaver'
      },
      userTypes: [
        {value: 'LA', title: 'Lærere'},
        {value: 'BH', title: 'Børnehaveklasseledere'},
        {value: 'PA', title: 'Pædagoger'},
        {value: 'LE', title: 'Ledere'},
        {value: 'AN', title: 'Andre med undervisningsopgaver'}
      ]
    }
  },
  computed: {
    personale () {
      return this.userTypes.map(usertype => {
        const obj = {
          title: usertype.title,
          male: this.getMalesFromTitle(usertype.title)
        }
        return obj
      })
    }
  },
  methods: {
    getMalesFromTitle (title) {
      this.userTypes
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.d-timetal__container__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.d-timetal__container {
  padding: 2rem 1rem;
  border: 1px solid #d8d8d8;
  width: 100%;
  border-radius: 4px;
}

.d-table {
  width: 100%;
  border: 1px solid #d8d8d8;
  border-collapse: collapse;
  border-radius: 4px;
}

.d-table thead {
  border-bottom: 1px solid #d8d8d8;
  background: #f6f9fc;
  color: #728195;
  text-transform: uppercase;
  border-radius: 4px;
  font-size: 11px;
}

.d-table thead th {
  padding: 0.5rem 1rem;
  text-align: left;
}

.d-table tbody tr {
  width: 100%;
  background: #f9fafb;
  border-bottom: 1px solid #e3e8ee;
}

.d-table tbody tr:nth-child(odd) {
  background: #ffffff;
}

.d-table tbody tr:hover {
  background: aliceblue;
}

.d-table tbody tr td {
  padding: 0.5rem 1rem;
  text-align: left;
  width: 75px !important;
}

input[type="number"]:focus {
  border-color: var(--blue);
}

input[type="number"] {
  height: 36px;
  background-color: #ffffff;
  border-radius: 4px;
  min-width: 80px;
  max-width: 80px;
  box-shadow: 0 0 #0000, 0 0 #0000, 0 1px 2px 0 rgb(0 0 0 / 0.05);
  border: 1px solid #d8d8d8;
  opacity: 1;
  text-align: center;
  -webkit-appearance: none !important;
  margin: 0 auto;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"].number--empty:focus {
  opacity: 1;
}

.d-filters__filter.d-filters__filter--active > .d-pill {
  background: #e0e7ff;
  color: var(--primary);
  border-color: transparent;
}

.d-filters__filter > .d-pill {
  margin-left: 1rem;
  border-radius: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  color: #111827;
  padding: 4px 8px;
  font-weight: bold;
  background: transparent;
  border: 1px solid rgba(204, 204, 204, 0.75);
  font-size: 11px;
}

thead.center th {
  text-align: center;
  font-size: 10px;
  border: 1px solid #d8d8d8;
  line-height: 1.2;
}

thead tr.thead-second-row th {
  font-size: 10px;
}

.text-explainer {
  font-size: 8px;
  margin-top: 0.75rem;
  line-height: 1.2;
}

.d-pill {
  background: #eee;
  font-size: 10px;
  color: #222222;
  display: inline-block;
  border-radius: 4px;
  padding: 4px 8px;
  line-height: 10px;
}

.name-and-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}

.filter-and-select {
  display: flex;
  align-items: center;
}

.filter-and-select .icon-filter {
  margin-right: 0.5rem;
}


.d-filters {
  display: inline-flex;
  align-items: center;
  border-radius: 4px;
}

.d-filters__filter {
  padding: 0.5rem 1.5rem;
  border: 1px solid #d8d8d8;
  border-width: 1px 1px 0 1px;
  margin-right: 1rem;
  border-radius: 4px 4px 0 0;
  display: flex;
  align-items: center;
  cursor: pointer;
  font-weight: bold;
}

.d-filters__filter.d-filters__filter--active {
  background: #f6f9fc;
  color: var(--primary)
}

.name-and-title__checkbox {
  display: flex;
  align-items: center;
}

.d-checkbox {
  margin-left: 0;
  margin-right: 1rem;
}

.select-all {
  text-align: left;
  color: var(--blue);
  text-transform: initial;
  cursor: pointer;
  user-select: none;
  transition: transform 0.25s;
}

.select-all:active {
  transform: scale(0.98);
}

.td__select-user {
  cursor: pointer;
  transition: transform 0.25s;
}

.td__select-user:active {
  transform: scale(0.98);
}

.up__button {
  background-color: #468ad7 !important;
  color: #fff !important;
  border: 1px solid #4e80b7 !important;
}

.select-all-and-button {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// ResumePersonaleSkema.vue?59cb160e